import React, {useState, createContext, useContext} from "react";


const Context=createContext();
const StateContext = ({children}) => {
    const [lightTheme, setLightTheme] = useState(true);
    const [linkHovred, setLinkHovred] = useState(false);
    const [isNotProject, setIsNotProject] = useState(true);
    const [prevLink, setPrevLink] = useState("");
    const [nextLink, setNextLink] = useState("");

    return (
        <Context.Provider value={{
            lightTheme,
            setLightTheme,
            linkHovred,
            setLinkHovred,
            isNotProject,
            setIsNotProject,
            prevLink,
            setPrevLink, 
            nextLink,
            setNextLink
        }}>
            {children}
        </Context.Provider>
    )
}
export default StateContext;

export const useStateContext=()=>useContext(Context);
